import store from '@/store'

const setup = (api: any) => {
  api.interceptors.response.use(async (response: any) => response, async (err: any) => {
    if (err.response.status === 401) {
      // console.log('xxxx')
      if (localStorage.getItem('rt')) {
        store.dispatch('refreshToken')
      } else {
        store.dispatch('logoutAccount')
      }
    }
    return Promise.reject(err)
  })
}

export default setup
